import React from 'react';
import { useTranslation } from 'react-i18next';
import { Block, FlexRow, SmallText, WarningIcon } from '@guryou/html-components';
import { borderDefinition, smallBorderRadius } from '@guryou/html-theme';
import { dealTokens } from 'components/shared';

const MobileWarningMessage = () => {
  const { t } = useTranslation();
  return (
    <FlexRow
      margin={0}
      alignItems="center"
      backgroundColor={dealTokens.color.warningSoft}
      xs={12}
      border={borderDefinition(dealTokens.color.warning, '2px')}
      borderRadius={smallBorderRadius}
    >
      <FlexRow alignItems="center" justifyContent="space-between" paddingLeft={2} margin={0}>
        <FlexRow xs={12} alignItems="center">
          <Block xs={1.2} margin={0}>
            <WarningIcon htmlColor={dealTokens.color.warning} />
          </Block>
          <SmallText xs={10.6} fontSize="0.9rem" fontWeight="800" color={dealTokens.color.text} textAlign="center">
            {t('ONBOARD.mobileWarningMessage')}
          </SmallText>
        </FlexRow>
      </FlexRow>
    </FlexRow>
  );
};

export default MobileWarningMessage;
